export const splitToChanks = <T>(list: T[], pageSize = 100) => {
  const chunks = [];
  let start = 0;
  while (list.length > start) {
    chunks.push(list.slice(start, start + pageSize));
    start += pageSize;
  }
  return chunks;
};
